import { useMutation, useQueryClient } from '@tanstack/react-query'

import { QUERY_KEYS } from '../../../lib/queryKeys'
import { rejectPackageReq } from '../packageReqService'

export const useRejectPkgReq = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: rejectPackageReq,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.PACKAGE_REQUESTS] })
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER_PACKAGES] })
    },
  })
}
